module.exports = __webpack_public_path__ + "static/media/work-sumimoto-tiny.95923c9d.jpg";